import styled from 'styled-components';

export const FaqHeader = styled.div`
font-size: 36px;
font-weight: 900;
letter-spacing: -0.25px;
color: #091740;
padding: 20px;
margin: auto;
text-align: center;
width: 100%;
`
export const FaqWrapper = styled.div`
width: 100%;
border-radius: 10px;
display: flex;
flex-direction: row;
padding-top: 50px;
padding-bottom: 50px;
`

export const Column = styled.div`
display: flex;
flex-direction: column;
justify-content: center;
width: 100%;
`

export const FaqMinihead = styled.p`
text-align: left;
font-size: 20px;
letter-spacing: 0px;
color: black;
`

export const FaqSubhead = styled.p`
text-align: left;
font-size: 20px;
letter-spacing: 0px;
color: #707070;
`